// extracted by mini-css-extract-plugin
export default {"local":"Burst_local__VaIp9","fullscreen":"Burst_fullscreen__ydSef","particle":"Burst_particle__+wGcc"};